export default __webpack_public_path__ + "static/einhornalone_meet-23cb2b4ab8301552f06038b76c44cccc.svg";